export class Notification{
    constructor(public title:string,public type:string,public msg:string,public show:boolean,public timeout:number){}
}